/** Fixed app header height (matches EduOKWeb NavMenuAdmin / Header Toolbar) */
export const APP_HEADER_HEIGHT = 72
